// extracted by mini-css-extract-plugin
module.exports = {"articleAuthor":"styles_articleAuthor__G2Q3B","authorInfo":"styles_authorInfo__1motq","authorName":"styles_authorName__sKCxf","authorDescription":"styles_authorDescription__Qz515"};